var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInterface3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 33.25 48.54",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#9caab2;}.cls-2{fill:#ccd6e5;}.cls-3{fill:#b8bcc0;}.cls-4{fill:#343f42;}.cls-5,.cls-7{fill:#d0d6e0;}.cls-6{fill:none;}.cls-6,.cls-7{stroke:#343f42;stroke-miterlimit:10;}"), /*#__PURE__*/React.createElement("symbol", {
    id: "Interface_02b",
    "data-name": "Interface_02b",
    viewBox: "0 0 33.25 48.54"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "6.65 12.54 6.65 48.54 33.25 39.9 33.25 3.9 6.65 12.54"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "26.56 0 33.25 3.9 6.65 12.54 0 8.7 26.56 0"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "0 8.7 6.65 12.54 6.65 48.54 0 44.7 0 8.7"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "23.27 10.14 23.27 25.14 29.93 22.98 29.93 7.98 23.27 10.14"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "23.27 28.14 23.27 40.14 29.93 37.98 29.93 25.98 23.27 28.14"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 9.97,
    y1: 17.46,
    x2: 19.85,
    y2: 14.2
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 9.97,
    y1: 20.46,
    x2: 19.85,
    y2: 17.2
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 9.97,
    y1: 23.46,
    x2: 19.85,
    y2: 20.2
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "9.97 29.46 19.95 26.22 19.95 41.22 9.97 44.46 9.97 29.46"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Fyldning_Inspektion",
    "data-name": "Fyldning & Inspektion"
  }, /*#__PURE__*/React.createElement("use", {
    width: 33.25,
    height: 48.54,
    xlinkHref: "#Interface_02b"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInterface3);
export default __webpack_public_path__ + "static/media/interface-3.ef133c75f437fa441af6b89a6a4db6dd.svg";
export { ForwardRef as ReactComponent };